import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { OfferSaleSearchResultsProps } from "./types";
import { useTranslate } from "helpers";
import { OFFER_SALE_SEARCH_COLUMNS } from "./consts";


const OfferSaleSearchResults: React.FC<
  OfferSaleSearchResultsProps
> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onVehicleClick,
    onContactClick,
    onDeleteClick,
  } = props;

  const { t } = useTranslate();
  return (
    <>
      <TableSearch
        columns={OFFER_SALE_SEARCH_COLUMNS(t, onVehicleClick, onContactClick, onDeleteClick)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}

       
      />
    </>
  );
};
export default memo(OfferSaleSearchResults);
